import * as React from "react";
import { Capacitor } from '@capacitor/core';

export type Platform = 'ios' | 'android' | 'web';

export function usePlatform() {
  const [platform, setPlatform] = React.useState<Platform>(() => {
    if (typeof window === 'undefined') return 'web';
    if (!Capacitor.isNativePlatform()) return 'web';

    const nativePlatform = Capacitor.getPlatform();
    if (nativePlatform === 'ios' || nativePlatform === 'android') {
      return nativePlatform;
    }
    return 'web';
  });
  
  React.useEffect(() => {
    // Check if running in a Capacitor container
    if (Capacitor.isNativePlatform()) {
      const nativePlatform = Capacitor.getPlatform();
      if (nativePlatform === 'ios') {
        setPlatform('ios');
      } else if (nativePlatform === 'android') {
        setPlatform('android');
      }
    }
  }, []);

  return platform;
} 
